import { __assign } from "tslib";
import React, { useEffect, useRef, useState } from "react";
import { IconContainer, ItemContainer, ModalContainer, ModalHeader, RestaurantImage, SearchInput, SearchLink, SecondLine, Subitem, SubitemsDiv, ThreadLine, } from "./styles";
import { FaCircle } from "react-icons/fa";
import { FaChevronLeft } from "react-icons/fa6";
import { HiMiniArrowTopRightOnSquare } from "react-icons/hi2";
export var SidebarItem = function (_a) {
    var _b;
    var item = _a.item, color = _a.color, user = _a.user, isOpen = _a.isOpen, isProfile = _a.isProfile, isSearch = _a.isSearch, setIsOpen = _a.setIsOpen, searchArray = _a.searchArray;
    var _c = useState([]), columnsArray = _c[0], setColumnsArray = _c[1];
    var generateColumns = function () {
        var columns = [];
        var currentColumn = 0;
        var currentIndex = 0;
        if (item.subitems) {
            item.subitems.forEach(function (subitem) {
                if (subitem.condition === false)
                    return;
                currentColumn += 40;
                if (columns[currentIndex] === undefined) {
                    columns[currentIndex] = [subitem];
                }
                else {
                    columns[currentIndex].push(subitem);
                }
                if (subitem.subitems) {
                    subitem.subitems.forEach(function (subsubitem) {
                        currentColumn += 40;
                        if (currentColumn > 160) {
                            currentColumn = 40;
                            currentIndex++;
                        }
                        if (columns[currentIndex] === undefined) {
                            columns[currentIndex] = [__assign(__assign({}, subsubitem), { isSubSub: true })];
                        }
                        else {
                            columns[currentIndex].push(__assign(__assign({}, subsubitem), { isSubSub: true }));
                        }
                    });
                }
                if (currentColumn >= 160) {
                    currentColumn = 0;
                    currentIndex++;
                }
            });
        }
        setColumnsArray(columns);
    };
    var getSubitemPath = function (subitem) {
        if (subitem.external)
            return "#";
        if (subitem.overridePath) {
            return subitem.overridePath;
        }
        var firstSubsubPath = null;
        if (item.path && subitem.subitems && subitem.subitems.length > 0) {
            firstSubsubPath = item.path + subitem.subitems[0].path;
        }
        if (firstSubsubPath) {
            return firstSubsubPath;
        }
        if (item.path && subitem.path) {
            return item.path + subitem.path;
        }
        return "#";
    };
    useEffect(function () {
        generateColumns();
    }, []);
    useEffect(function () {
        if (setIsOpen) {
            window.addEventListener("click", function () {
                setIsOpen("");
            });
        }
        generateColumns();
        return function () {
            window.removeEventListener("click", function () {
                setIsOpen("");
            });
        };
    }, []);
    var inputRef = useRef(null);
    var _d = useState(""), filter = _d[0], setFilter = _d[1];
    return (React.createElement(ItemContainer, { disabled: item.disabled, to: (!item.subitems || ((_b = item.subitems) === null || _b === void 0 ? void 0 : _b.length) <= 0) && item.path
            ? item.path
            : "#", onClick: function (e) {
            var _a;
            if (item.external) {
                window.open(item.external, item.externalRef);
            }
            if ((!item.subitems || ((_a = item.subitems) === null || _a === void 0 ? void 0 : _a.length) <= 0) && (!isSearch || (isSearch && item.subitems))) {
            }
            else {
                e.stopPropagation();
                if (isSearch && inputRef.current === e.target)
                    return;
                setIsOpen(isOpen ? "" : item.text);
                setFilter("");
            }
        } },
        React.createElement(IconContainer, { color: color },
            item.icon,
            React.createElement("div", null,
                React.createElement("span", null, item.text))),
        React.createElement(ModalContainer, { open: isOpen },
            isProfile && user ? (React.createElement(React.Fragment, null,
                React.createElement(ModalHeader, { color: color }, user.fantasy_name),
                React.createElement("div", { style: {
                        display: "flex",
                        width: "100%",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "20px",
                        marginBottom: "10px"
                    } }, user.avatar.url && (React.createElement(RestaurantImage, { src: user.avatar.url }))))) : (React.createElement(ModalHeader, { color: color },
                React.createElement(FaChevronLeft, { color: color }),
                item.text)),
            isSearch && (React.createElement("div", { style: { paddingTop: 5, paddingLeft: 10, paddingRight: 10 } },
                React.createElement(SearchInput, { ref: inputRef, value: filter, onChange: function (e) { return setFilter(e.target.value); } }),
                React.createElement(SearchLink, { to: "/search" },
                    "Ver tudo",
                    React.createElement("div", { style: { display: "flex", flex: 1, alignItems: "center" } },
                        React.createElement(HiMiniArrowTopRightOnSquare, { color: "#666", size: 18 }))),
                filter && (searchArray === null || searchArray === void 0 ? void 0 : searchArray.filter(function (item) { return item.text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').includes(filter); }).map(function (item, idx) { return (React.createElement(SearchLink, { to: item.external ? "#" : item.path, key: idx, style: { textDecoration: "none" }, onClick: function () {
                        if (item.external) {
                            window.open(item.external, item.externalRef);
                        }
                    } }, item.text)); })))),
            React.createElement("div", { style: { display: "flex" } }, columnsArray.map(function (col, colIdx) {
                var lastCol = colIdx === columnsArray.length - 1;
                return (React.createElement(SubitemsDiv, { key: colIdx }, col.map(function (subitem, idx) {
                    if (subitem.condition === false)
                        return;
                    return (React.createElement(Subitem, { to: getSubitemPath(subitem), key: idx, isSubSub: subitem.isSubSub, color: color, onClick: function () {
                            if (subitem.external) {
                                window.open(subitem.external, subitem.externalRef);
                            }
                        } },
                        subitem.isSubSub && React.createElement(ThreadLine, { isFirst: idx === 0 }),
                        ((subitem.subitems && subitem.subitems.length > 0) ||
                            subitem.isSubSub) && React.createElement(FaCircle, null),
                        subitem.text,
                        idx === 3 &&
                            !lastCol &&
                            (subitem.isSubSub ||
                                (subitem.subitems &&
                                    subitem.subitems.length > 0)) && React.createElement(SecondLine, null)));
                })));
            })))));
};
//# sourceMappingURL=index.js.map